import { TypedSupabaseClient } from "../../utils/types";

export function getValets(
  client: TypedSupabaseClient,
  pageIndex: number | null,
  pageSize: number | null,
  sortingColumn: string | null,
  isDescending: boolean,
  searchQuery: string | null
) {
  let query = client
    .from("users")
    .select(
      `email,full_name,id,oid,roles,scheduler_ext_id,status,updated_at,username,venue_id, venue:venues(name, id)`
    )
    .eq("archived", false);

  if (searchQuery) {
    query = query.ilike("full_name", `%${searchQuery}%`);
  }

  if (pageSize && pageIndex !== null) {
    const start = pageIndex * pageSize;
    const end = start + pageSize - 1;
    query = query.range(start, end);
  }

  if (sortingColumn) {
    query = query.order(sortingColumn, { ascending: !isDescending });
  }

  return query;
}
